import { useState, useEffect } from 'react';

import { apiContainer } from '@vlabs/api-bindings';

export const useImageRescale = (imageUrl) => {
  const [rescale, setRescale] = useState(null);

  useEffect(() => {
    if (!imageUrl) return;

    const getRescaleFactor = async () => {
      try {
        const rescaleFactor = await apiContainer.lunaClient.images.getRescaleFactor(imageUrl);
        setRescale(rescaleFactor);
      } catch (rescaleError) {
        setRescale(1);
      }
    };

    getRescaleFactor();
  }, [imageUrl]);

  return rescale;
};
